<template>
      <div class='item-grid carosuel-container'>
        <div :id='"popout_product_images_carosuel_"+product.code' class="swiper mySwiper">
           <div class='swiper-wrapper'>
                <template v-for='image in product.images' :key='image.code'>
                    <div class="swiper-slide product-card">
                        <DynamicImageContainer class="product-image" :image='image'/>
                        <!-- <ProductCard :product='slide'/> -->
                    </div>
                </template>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components: {DynamicImageContainer},
    props: ['product', 'product_code_changed_watcher'],
      data(){
        return{
            swiper: null,
            number_of_slides: 0,
            loading: true,
            glide_instance: null
        }
    },
    methods:{
        createCarousel(){
            if(this.swiper != null){
                this.swiper.destroy();
            }
            this.swiper = new Swiper(`#popout_product_images_carosuel_${this.product.code}`, {
                modules: [Navigation, Pagination],
                loop: false,
                slidesPerView: '2',
                spaceBetween: '20',
                centerInsufficientSlides: true,
                watchSlidesVisibility: true,
                cssMode: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });
        },
    },
    watch:{
        'product_code_changed_watcher': function(){
            setTimeout(() => {
                this.createCarousel();
            }, 1);
        }
    }
}
</script>

<style lang="scss">
.swiper-pagination-bullet-active {
    background-color: #233142;
}
.swiper-button-next {
    color: #233142;
}
.swiper-button-prev {
    color: #233142;
}
</style>

<style lang="scss" scoped>

.product-card{
    width: 200px;
    height: 300px;
}

.product-image{
    object-fit: cover;
    object-position: 50% 0;
    width: 200px;
}

.carosuel-container{
    z-index: 1000;
}

.glide__arrows{
    position: absolute;
    top: 40%;
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-left: 15px;
    padding-right: 15px;
    color: var(--black);

    @media(max-width: 768px){
        padding-left: 0px;
        padding-right: 0px;
        // margin-left: -10px;
    }
}

.right-arrow{
    @media(max-width: 768px){
        margin-right: -20px;
    }
}

.left-arrow{
    @media(max-width: 768px){
        margin-left: -20px;
    }
}

// .item-grid {
//     display: grid;
//     grid-template-columns: 1fr;
//     width: 100%;
//     z-index: 0;
// }
// .item-grid > :first-child {
//   min-width: 100%;
// }
</style>